import { authenticatedFetch } from "./authenticatedFetch";
import { formatApiErrorMessage } from "../utils/apiErrorMessage";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

class CustomerService {
  async saveCustomer(payload) {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/customers/save`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        let errorBody = null;
        try {
          errorBody = await response.json();
        } catch {
          /* ignore */
        }
        return {
          success: false,
          error: errorBody || "Erro ao salvar cliente",
        };
      }

      const data = await response.json();

      return {
        success: true,
        data,
      };
    } catch (error) {
      console.error("saveCustomer error:", error);
      return {
        success: false,
        error: formatApiErrorMessage(error, "Erro inesperado ao salvar cliente"),
      };
    }
  }

  async getCustomer(id) {
    try {
      const response = await authenticatedFetch(
        `${API_BASE_URL}/customers/${encodeURIComponent(id)}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (!response.ok) {
        let errorBody = null;
        try {
          errorBody = await response.json();
        } catch {
          /* ignore */
        }
        return {
          success: false,
          error: errorBody || "Erro ao buscar cliente",
        };
      }

      const data = await response.json();

      return {
        success: true,
        data,
      };
    } catch (error) {
      console.error("getCustomer error:", error);
      return {
        success: false,
        error: "Erro inesperado ao buscar cliente",
      };
    }
  }

  async getCustomers() {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/customers`, {
        method: "GET",
        credentials: "include",
      });

      if (!response.ok) {
        let errorBody = null;
        try {
          errorBody = await response.json();
        } catch {
          /* ignore */
        }
        return {
          success: false,
          error: errorBody || "Erro ao listar clientes",
        };
      }

      const data = await response.json();

      return {
        success: true,
        data,
      };
    } catch (error) {
      console.error("getCustomers error:", error);
      return {
        success: false,
        error: "Erro inesperado ao listar clientes",
      };
    }
  }

  async deleteCustomer(id) {
    try {
      const response = await authenticatedFetch(
        `${API_BASE_URL}/customers/delete/${encodeURIComponent(id)}`,
        {
          method: "DELETE",
          credentials: "include",
        }
      );

      if (!response.ok) {
        let errorBody = null;
        try {
          errorBody = await response.json();
        } catch {
          /* ignore */
        }
        return {
          success: false,
          error: errorBody || "Erro ao excluir cliente",
        };
      }

      return { success: true };
    } catch (error) {
      console.error("deleteCustomer error:", error);
      return {
        success: false,
        error: "Erro inesperado ao excluir cliente",
      };
    }
  }
}

export default new CustomerService();
